var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('div',{staticClass:"expandible-button-wrapper"},[_c('IconButton',{attrs:{"icon":_vm.icon}}),_c('div',{staticClass:"expandible-button-options",class:{ 'expandible-button-options-expanded': hover }},[_vm._t("default")],2)],1)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }